import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Input from '@components/Input';
import Modal from '@components/Modal/next/Modal';
import { BaseCheckIcon } from '@assets/icons';

import { TurkTelekomModalSchema } from '../schemas';
import {
  PromotionsConfigs,
  Promotion,
  sharedProps,
  PROMOTION_TYPES,
} from './common';
import { Button } from '../common/styled';
import ModalFooterTurkTelekom from './ModalFooterTurkTelekom';
import { Bold, Content, Paragraph, Section } from './styled';

export interface TurkTelekomModalFormData {
  phoneNumber: string;
  turkTelekomCode: string;
}

const initialValues = {
  phoneNumber: '',
  turkTelekomCode: '',
};
interface TTModalProps {
  isVisible?: boolean;
  isValidated?: boolean;
  promotion?: Promotion;
  onCancel: () => void;
  onSubmit: (data: TurkTelekomModalFormData) => void;
}
const TTModal = ({
  isValidated = false,
  promotion = 'turktelekom',
  onCancel,
  onSubmit,
  ...rest
}: TTModalProps) => {
  const {
    opening,
    Logo,
    logoWidth,
    logoHeight,
    promotionCodeLabel,
    ...promotionProps
  } = PromotionsConfigs[promotion];

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<TurkTelekomModalFormData>({
    defaultValues: initialValues,
    resolver: yupResolver(TurkTelekomModalSchema),
  });
  return (
    <Modal
      borderRadius={8}
      {...sharedProps}
      {...rest}
      {...promotionProps}
      onCancel={onCancel}
      footer={
        PromotionsConfigs ? (
          <ModalFooterTurkTelekom
            promotions={PromotionsConfigs}
            promotion={promotion}
          />
        ) : null
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Content>
          <Logo width={logoWidth} height={logoHeight} />
          <Section>
            {promotion === PROMOTION_TYPES.TURKTELEKOM ? (
              <Paragraph>
                {opening} <Bold>Bi’ Dünya Fırsat</Bold> şimdi de{' '}
                <Bold>Setur’da</Bold>. Seçili otellerde geçerli mevcut
                indirimlere ek %5 indirimden faydalanmak için{' '}
                <Bold>cep telefonu numaranızı ve kampanya şifrenizi girin</Bold>
                .
              </Paragraph>
            ) : null}
            {promotion === PROMOTION_TYPES.TTPRIME ? (
              <Paragraph>
                {opening} <Bold>kat kat ayrıcalıkları</Bold> şimdi de{' '}
                <Bold>Setur’da</Bold>. Seçili otellerde geçerli mevcut
                indirimlere ek %10 indirimden faydalanmak için{' '}
                <Bold>cep telefonu numaranızı ve kampanya şifrenizi girin</Bold>
                .
              </Paragraph>
            ) : null}
            {promotion === PROMOTION_TYPES.TTBUSINESS ? (
              <Paragraph>
                {opening} <Bold>kat kat ayrıcalıkları</Bold> şimdi de{' '}
                <Bold>Setur’da</Bold>. Seçili otellerde geçerli mevcut
                indirimlere ek %10 indirimden faydalanmak için{' '}
                <Bold>cep telefonu numaranızı ve kampanya şifrenizi girin</Bold>
                .
              </Paragraph>
            ) : null}
          </Section>
          <Section>
            <Controller
              control={control}
              name='phoneNumber'
              render={({ field }) => (
                <Input
                  {...field}
                  label='Cep Telefonu Numarası*'
                  error={Boolean(errors.phoneNumber)}
                />
              )}
            />
            <Controller
              control={control}
              name='turkTelekomCode'
              render={({ field }) => (
                <Input
                  {...field}
                  label={promotionCodeLabel}
                  error={Boolean(errors.turkTelekomCode)}
                />
              )}
            />

            <Button
              disabled={isSubmitting}
              outline
              size='large'
              type='submit'
              isValid={isValidated}
              hasHover={false}
            >
              <span>{!isValidated ? 'Doğrula' : 'Doğrulandı'}</span>
              <BaseCheckIcon width={24} height={24} />
            </Button>
          </Section>
        </Content>
      </form>
    </Modal>
  );
};

export default TTModal;
